export default "__VITE_ASSET__BlNoXe0N__"